import styles from './Navbar.module.css';
import { BUSINESS_NAME, SYSTEM_URL } from '../constants';

export default function Navbar({ accent }) {
  return (
    <nav className={styles.nav}>
      <div className={styles.brand}>
       <img
  src="/images/logo.png"
  alt="Glory's Boutique"
  className={styles.logoImg}
/>
       0
      </div>

      <a
        href={SYSTEM_URL}
        className={styles.cta}
        style={{ borderColor: accent, color: accent }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Sistema →
      </a>
    </nav>
  );
}
